import { Component, EventEmitter, Output, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { PersonSel } from '@app/cp/shared/models/PersonSelBus';
import { GItem } from '../../models/GItem';
import { EmployeeService } from '../../services/employee.service';
import { PersonNotesBus } from '../../models/PersonNotesBus';
import { BaseAppMComponent } from '../../base-components/base-app-m.component';
import { DQOIReferenceDataQuery } from '../../../dqoi/state/dqoi-reference-data.query';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'emp-note',
    templateUrl: './emp-note.component.html',
    styleUrls: ['./emp-note.component.scss'],
    standalone: false
})
export class EmpNoteComponent extends BaseAppMComponent<PersonNotesBus, EmployeeService, null,null> {

    constructor(globals: GlobalsService,
        svc_data: EmployeeService,
        qry_rd: DQOIReferenceDataQuery,
        featureFlagService: FeatureFlagService,
        ) {
        super(globals, featureFlagService, qry_rd);
        this.svc_data = svc_data;
        this.createForm();
        this.appCode="Employee Note"
    }
    @Input() sublings: GItem[] = [];
    @Input()  persons: PersonSel[];
    @Input()  appCode: string;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();

    personId: any;
    note: string;

    active: boolean = false;
    data: any;
    createForm() {
        this.editForm = new UntypedFormGroup({
            'note': new UntypedFormControl('', Validators.required),
            'personId': new UntypedFormControl(''),
        });

    }
    hide() {
        this.active = false;
        this.data = null;
    }

    ok() {
        this.saveNote();
    }
    cancel() {
        this.hide();
    }
    close() {
        this.closed.emit(null);
        this.hide();
    }
    public show(id: any) {

        this.active = true;
        this.createForm();

    }
    saveNote() {
        let user = this.globals.user;

        let busObj: PersonNotesBus = new PersonNotesBus();
        busObj.note = this.editForm.value.note;
        busObj.personId = this.editForm.value.personId;
        busObj.personNotePersonId = user.personId;
        busObj.insertUserid = user.userid;
        busObj.updateUserId = user.userid;
        this.svc_data.saveNote(busObj).subscribe(data => {
            if (!data.saveError) {
                this.saveSuccess();
                this.hide();
            }
            else {
                this.saveError();
            }
        }

        );

    }
}

